// extracted by mini-css-extract-plugin
module.exports = {"button":"option-menu_button__-KToz"};